import btoa from 'btoa';
import {
  COMPLETE_SIGN_UP,
  RESTORE_TOKEN,
  SIGN_IN,
  SIGN_OUT,
  SIGNING_UP,
  VERIFYING_USER,
} from './authTypes';

export const authReducer = (prevState, action) => {
  switch (action.type) {
    case RESTORE_TOKEN:
      return {
        ...prevState,
        email: action.email,
        cognitoId: action.cognitoId,
        userToken: action.token,
        userType: action.userType,
        isLoading: false,
        // firstTimeUser: true,
      };
    case COMPLETE_SIGN_UP:
      return {
        ...prevState,
        isLoading: false,
        firstTimeUser: false,
      };
    case SIGNING_UP:
      return {
        ...prevState,
        isLoading: false,
        firstTimeUser: true,
        email: action.email,
        password: btoa(action.password),
      };
    case VERIFYING_USER:
      return {
        ...prevState,
        cognitoId: action.cognitoId,
        email: action.email,
        password: null, //only needed to store it
        userToken: action.token,
        userType: action.userType,
      };
    case SIGN_IN:
      return {
        ...prevState,
        cognitoId: action.cognitoId,
        email: action.email,
        userToken: action.token,
        userType: action.userType,
        isSignout: false,
      };
    case SIGN_OUT:
      return {
        ...prevState,
        cognitoId: null,
        isSignout: true,
        userToken: null,
        userType: null,
      };
    default:
      return prevState;
  }
};
